const STORAGE_KEY = 'cadira.activeAuthSession';

function hasWindow() {
	return typeof window !== 'undefined' && !!window.localStorage;
}

function generateSessionId() {
	if (typeof globalThis.crypto?.randomUUID === 'function') {
		return globalThis.crypto.randomUUID();
	}

	return `sess_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
}

function readStoredAuthSession() {
	if (!hasWindow()) return null;

	try {
		const raw = window.localStorage.getItem(STORAGE_KEY);
		if (!raw) return null;
		const parsed = JSON.parse(raw);
		return parsed && typeof parsed === 'object' ? parsed : null;
	} catch (error) {
		window.localStorage.removeItem(STORAGE_KEY);
		return null;
	}
}

function writeStoredAuthSession(data) {
	if (!hasWindow()) return;
	window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

export function getStoredAuthSession() {
	return readStoredAuthSession();
}

export function getStoredAuthSessionId() {
	return readStoredAuthSession()?.sessionId || null;
}

export function getStoredAuthSessionUserId() {
	return readStoredAuthSession()?.userId || null;
}

export function isPendingAuthSessionTakeover() {
	return readStoredAuthSession()?.pendingTakeover === true;
}

export function beginPendingAuthSessionTakeover() {
	const sessionId = generateSessionId();
	writeStoredAuthSession({
		sessionId,
		userId: null,
		pendingTakeover: true,
	});
	return sessionId;
}

export function finalizeStoredAuthSession({ userId, sessionId }) {
	writeStoredAuthSession({
		sessionId,
		userId,
		pendingTakeover: false,
	});
}

export function clearStoredAuthSession() {
	if (!hasWindow()) return;
	window.localStorage.removeItem(STORAGE_KEY);
}
